import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-webbtree-footer',
    templateUrl: './webbtree-footer.component.html',
    styleUrls: ['./webbtree-footer.component.scss'],
    standalone: false
})
export class WebbtreeFooterComponent implements OnInit {
  currentyear: number = new Date().getFullYear();
  constructor() { }

  ngOnInit() {
    
  }

}
